import { SpecialityClassificationDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { SpecialityClassification } from '@/services/graphql/types';

export const mapperSpecialityClassificationDataEnum = createEnumMapperFunction(
  SpecialityClassification,
  SpecialityClassificationDataEnum
);
